/** Detect assistant message wire format and trim partial markdown during SSE streaming. */

const ASSISTANT_HTML_TAG_RE =
  /<\s*\/?\s*(p|ul|ol|li|h[1-6]|div|table|blockquote|pre|br|strong|em)\b/i;

export function looksLikeAssistantHtml(content: string | null | undefined): boolean {
  const trimmed = (content ?? "").trim();
  if (!trimmed) {
    return false;
  }
  if (ASSISTANT_HTML_TAG_RE.test(trimmed)) {
    return true;
  }
  return trimmed.startsWith("<");
}

/** Strip trailing incomplete markdown constructs so partial SSE chunks render safely. */
export function trimPartialMarkdown(content: string): string {
  let text = content;

  const openBracket = text.lastIndexOf("[");
  const closeBracket = text.lastIndexOf("]");
  if (openBracket > closeBracket) {
    text = text.slice(0, openBracket);
  }

  const partialUrl = /\]\([^)]*$/.exec(text);
  if (partialUrl) {
    text = text.slice(0, partialUrl.index + 1);
  }

  const fenceCount = (text.match(/```/g) ?? []).length;
  if (fenceCount % 2 === 1) {
    const lastFence = text.lastIndexOf("```");
    if (lastFence >= 0) {
      text = text.slice(0, lastFence);
    }
  }

  const backtickCount = (text.match(/`/g) ?? []).length;
  if (backtickCount % 2 === 1) {
    const lastTick = text.lastIndexOf("`");
    if (lastTick >= 0) {
      text = text.slice(0, lastTick);
    }
  }

  const boldCount = (text.match(/\*\*/g) ?? []).length;
  if (boldCount % 2 === 1) {
    const lastBold = text.lastIndexOf("**");
    if (lastBold >= 0) {
      text = text.slice(0, lastBold);
    }
  }

  return text;
}
